<template>
  <div>
    <div
      :key="customSet.key"
      class="d-flex justify-content-between mb-2 over-highlight align-items-center customSet"
    >
      <t-checkbox :value="customSet.key">{{ customSet.name }}</t-checkbox>
      <div
        class="hover-item py-1"
        style="flex: 0 0 92px"
      >
        <!--Remove column set-->
        <t-button
          variant="link"
          size="sm"
          class="text-secondary p-0 mr-2"
          @click.stop="$emit('removeColumn', customSet)"
        >
          <fluency-icon type="delete" />
        </t-button>

        <!--Share column set-->
        <span
          v-p-tooltip.top="'Share with your coworkers'"
          class="p-0 mr-2 cursor-pointer hover-icon"
          @click="toggleSavePanel('shareColumnOpen')"
        >
          <fluency-icon type="share" />
        </span>

        <!--Edit name of set-->
        <span
          v-p-tooltip.top="'Edit the Name'"
          class="p-0 mr-2 cursor-pointer hover-icon"
          @click="toggleSavePanel('editNameOpen')"
        >
          <fluency-icon type="edit" />
        </span>

        <!--Save current columns into column set-->
        <t-button
          v-p-tooltip.top="'Save the selected columns into this one'"
          variant="link"
          size="sm"
          class="p-0 ml-2"
          @click.stop="$emit('saveColumnsIntoSet', customSet)"
        >
          <fluency-icon type="save" />
        </t-button>
      </div>
    </div>

    <!--Share column set-->
    <simple-cancel-save
      v-model="customSet.name"
      :show="editNameOpen"
      @update:show="editNameOpen = !editNameOpen"
      @save="$emit('saveColumn')"
    >
      <template #edit="{ value, update, validate }">
        <t-form-group label="Edit the Name">
          <p-input-text
            :model-value="value"
            @update:modelValue="(update($event), validate($event && $event.length > 0))"
          />
        </t-form-group>
      </template>
    </simple-cancel-save>

    <!--Edit name of set-->
    <simple-cancel-save
      :value="''"
      :show="shareColumnOpen"
      @update:show="shareColumnOpen = !shareColumnOpen"
      @save="$emit('shareColumn', { columnSet: customSet, shareWith: $event })"
    >
      <template #edit="{ value, update }">
        <t-form-group label="Share With Coworkers">
          <t-multi-input
            :model-value="value"
            placeholder="myCoworker@awesome.agency"
            @update:modelValue="update"
          />
        </t-form-group>
      </template>
    </simple-cancel-save>
  </div>
</template>

<script>
import SimpleCancelSave from '@/components/common/simpleCancelSave'

export default {
  name: 'ColumnEditActions',
  components: { SimpleCancelSave },
  props: ['customSet'],
  data () {
    return {
      saveAsOpen: false,
      editNameOpen: false,
      shareColumnOpen: false
    }
  },
  methods: {
    toggleSavePanel (type) {
      if (type === 'saveAsOpen') {
        this.saveAsOpen = !this.saveAsOpen
        this.editNameOpen = false
        this.shareColumnOpen = false
      }
      if (type === 'editNameOpen') {
        this.editNameOpen = !this.editNameOpen
        this.saveAsOpen = false
        this.shareColumnOpen = false
      }
      if (type === 'shareColumnOpen') {
        this.shareColumnOpen = !this.shareColumnOpen
        this.editNameOpen = false
        this.saveAsOpen = false
      }
    }
  }
}
</script>
